export class CommunicationPreferences {
  emailAddress: string;
  faxNumber: string;
  smsNumber: string;
  sendSMS: boolean;
  sendEmail: boolean;

  constructor(emailAddress?: string, faxNumber?: string, smsNumber?: string, sendSMS?: boolean, sendEmail?: boolean) {
    this.emailAddress = emailAddress;
    this.faxNumber = faxNumber;
    this.smsNumber = smsNumber;
    this.sendSMS = sendSMS;
    this.sendEmail = sendEmail;
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/model/communication/communication.preferences.model.ts